import { CircleNotchIcon } from '@phosphor-icons/react';
import { Icon } from '@sr/ui-library';
import { twMerge } from 'tailwind-merge';

export interface ILoaderProps extends ISpinnerProps {
  className?: string;
  loaderHeight?:
    | 'h-32'
    | 'h-40'
    | 'h-48'
    | 'h-64'
    | 'h-80'
    | 'h-96'
    | 'h-full'
    | 'h-screen';
}

export interface ISpinnerProps {
  className?: string;
  size?: string;
}

export const Spinner = ({ className, size = '8' }: ISpinnerProps) => {
  return (
    <Icon
      className={twMerge('animate-spin', `size-${size}`, className)}
      data-testid="spinner-icon"
      icon={CircleNotchIcon}
    />
  );
};

const LoaderV2 = ({ loaderHeight = 'h-screen', size = '2' }: ILoaderProps) => {
  return (
    <div
      className={`absolute mx-[50%] w-full ${loaderHeight}`}
      data-testid="loader-container"
    >
      <Spinner size={size} />
    </div>
  );
};

const FlexLoader = ({ className, loaderHeight, size = '8' }: ILoaderProps) => {
  return (
    <div
      className={twMerge(
        'flex w-full flex-col items-center justify-center',
        loaderHeight,
        className,
      )}
      data-testid="flex-loader"
    >
      <Spinner size={size} />
    </div>
  );
};

const Overlay = () => {
  return (
    <div
      className="absolute inset-0 flex items-center justify-center"
      data-testid="loader-overlay"
    >
      <div
        className="absolute inset-0 z-10 bg-white opacity-75"
        data-testid="overlay-background"
      />
      <FlexLoader
        className="absolute inset-0 z-50 bg-transparent"
        data-testid="overlay-loader"
      />
      <span className="sr-only">loading</span>
    </div>
  );
};

const AbsoluteLoader = ({
  className,
  loaderHeight = 'h-screen',
  size = '8',
}: ILoaderProps) => {
  return (
    <div className={className} data-testid="absolute-loader">
      <div
        className={`absolute top-1/2 w-full text-center ${loaderHeight}`}
        data-testid="absolute-loader-inner"
      >
        <Spinner size={size} />
      </div>
    </div>
  );
};

export const AppLoader = Object.assign(LoaderV2, {
  AbsoluteLoader,
  FlexLoader,
  Overlay,
  Spinner,
});

export default AppLoader;
